export class VisibilityChecker {
	static isElementCenterInViewport(element: Element): boolean {
		const bounding = element.getBoundingClientRect();
		const center = {
			x: 0.5 * (bounding.left + bounding.right),
			y: 0.5 * (bounding.top + bounding.bottom),
		};
		const max = {
			x: window.innerWidth || document.documentElement.clientWidth,
			y: window.innerHeight || document.documentElement.clientHeight,
		};
		const isInCenter = center.x >= 0 && center.x <= max.x && center.y >= 0 && center.y <= max.y;
		return isInCenter;
	}

	static isElementFullyInViewport(element: Element): boolean {
		const bounding = element.getBoundingClientRect();
		return (
			bounding.top >= 0 &&
			bounding.left >= 0 &&
			bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	}
}
